module.exports = {"TXTWCL_Other_balances":{"id":"TXTWCL_Other_balances","defaultMessage":"Anderes Guthaben"}}